import React from 'react';

import { AutoComplete as AntAutoComplete, AutoCompleteProps } from 'antd';
import { DefaultOptionType } from 'antd/lib/select';

export interface IAutoCompleteProps extends AutoCompleteProps {}

export interface OptionProps extends Omit<DefaultOptionType, 'label'> {
  children: React.ReactNode;
  /** Save for customize data */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [prop: string]: any;
}
type TAutoComplete = React.FC<IAutoCompleteProps> & {
  Option: React.FC<OptionProps>;
};

export const AutoComplete: TAutoComplete = (props) => (
  <AntAutoComplete {...props} />
);

AutoComplete.Option = AntAutoComplete.Option;
